import React, { useEffect } from 'react';

const Home = () => {
  useEffect(()=> {
    if (document.getElementById('mobile-menu').classList.contains("flex")) {
      document.getElementById('mobile-menu').classList.replace("flex", "hidden");
    }
  }, [])

  return (
    <div className="container px-4 md:px-12 lg-px-24 mt-4 h-screen flex flex-col justify-center">
      <div>
        <h2 className="text-4xl mb-5 lg:mb-10">Hi, I'm Williams.</h2>
      </div>
      <div>
        <h1 className="text-5xl lg:text-7xl font-bold mb-5 lg:mb-10">Web Developer. <br />Full Stack Developer.</h1>
      </div>
      <div>
        <h3 className="text-3xl">I use modern technologies to create <br/> applications that make life easy for users.</h3>
      </div>
    </div>
  );
};

export default Home;
